import * as React from "react"
import {Box, Typography} from "@mui/material";
import {formatNumber, formatPercentage, formatPrice} from "@ui-seeker/utils";


export default function PriceEvolutionPriceBlock({ isDiscount, price, listPrice, currency, showListPrice=true, showCurrency=true, decimals=2, forceShowListPrice }) {

	const _formatPrice = p => showCurrency
		? formatPrice(p, currency, { decimals })
		: formatNumber(p, { decimals })

	return <Box sx={{ textAlign: 'center', width: '100%' }}>
		{ isDiscount ?  formatPercentage(price) : _formatPrice(price)}
		{ ((!!listPrice && showListPrice) || forceShowListPrice) && <Typography variant="body2" sx={{ color: 'text.disabled', fontSize: '0.8rem' }}>
			{_formatPrice(listPrice)}
		</Typography>  }
	</Box>
}